import React, { createContext, useContext, useMemo } from "react"

import { Permission } from "constants/permissions"

import { useProps } from "./PropsContext"

type PermissionsCtx = {
  has: (p: Permission) => boolean
  hasAny: (ps: Permission[]) => boolean
}

const Ctx = createContext<PermissionsCtx>({ has: () => false, hasAny: () => false })

export const PermissionsProvider = ({ children }: { children: React.ReactNode }) => {
  const { user } = useProps()

  const value = useMemo<PermissionsCtx>(() => {
    const set = new Set<string>(user?.permissions ?? [])
    return {
      has: (p: Permission) => set.has(p),
      hasAny: (ps: Permission[]) => ps.some((p) => set.has(p))
    }
  }, [user?.permissions])

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export const usePermissions = (): PermissionsCtx => useContext(Ctx)
